import React, { useState, useEffect, useCallback } from "react";
import { API_URL } from "../../utils/config";
import { mapejos } from "../../utils/Mapejos";
import TeclaEscEnter from "../../utils/Teclaescenter";
import AjudaTreball from "./AjudaTreball";
import { BotoAjuda } from "./AjudaModal";
import "./treballs.css";
import "../dashboard.css";

function Organitzacio({ treball, onCancel, subnav }) {
  const [tasquesList, setTasquesList] = useState([]);
  const [relacions, setRelacions] = useState([]);
  const [tascaFocus, setTascaFocus] = useState(null);
  const [filtreRelacio, setFiltreRelacio] = useState("Totes");
  const [fDescripcio, setFDescripcio] = useState("");

  const [modeAfegir, setModeAfegir] = useState(null);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [motiuComu, setMotiuComu] = useState("");

  const [editingRelId, setEditingRelId] = useState(null);
  const [editMotiu, setEditMotiu] = useState("");
  const [mostraAjuda, setMostraAjuda] = useState(false);

  TeclaEscEnter(modeAfegir ? () => setModeAfegir(null) : onCancel, null);

  const fetchTasques = useCallback(async () => {
    if (!treball?.idTreballs) return;
    try {
      const resp = await fetch(`${API_URL}/TasquesTreball.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idTreballs: treball.idTreballs }),
      });
      const data = await resp.json();
      if (data.success) setTasquesList(data.tasques || []);
    } catch (err) {
      console.error("Error carregant tasques:", err);
    }
  }, [treball]);

  const fetchRelacions = useCallback(async () => {
    if (!treball?.idTreballs) return;
    try {
      const body = { idTreballs: treball.idTreballs };
      if (tascaFocus) body.idTasca = tascaFocus.idTasques;

      const resp = await fetch(`${API_URL}/OrganitzacioTasques.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await resp.json();
      if (data.success) setRelacions(data.relacions || []);
    } catch (err) {
      console.error("Error carregant relacions:", err);
    }
  }, [treball, tascaFocus]);

  useEffect(() => { fetchTasques(); }, [fetchTasques]);
  useEffect(() => { fetchRelacions(); }, [fetchRelacions]);

  const classificarRelacions = () => {
    if (!tascaFocus) return [];
    const idFocus = tascaFocus.idTasques;

    return relacions.map((r) => {
      let tipusRelatiu;
      if (r.TipusDependencia === "Excloent") {
        tipusRelatiu = "Excloent";
      } else if (r.idTasca === idFocus) {
        tipusRelatiu = "Dependents";
      } else {
        tipusRelatiu = "Predecessores";
      }

      const idAltra = r.idTasca === idFocus ? r.idTascaDependent : r.idTasca;
      const descAltra = r.idTasca === idFocus ? r.DescripcioTasca2 : r.DescripcioTasca1;

      return { ...r, tipusRelatiu, idAltra, descAltra };
    });
  };

  const relacionsClassificades = classificarRelacions();
  const relacionsFiltrades = filtreRelacio === "Totes"
    ? relacionsClassificades
    : relacionsClassificades.filter((r) => r.tipusRelatiu === filtreRelacio);

  const tasquesFiltrades = tasquesList.filter((t) => {
    if (fDescripcio && !(t.DescripcioTasca || "").toLowerCase().includes(fDescripcio.toLowerCase())) return false;
    return true;
  });

  const getCandidates = () => {
    if (!tascaFocus || !modeAfegir) return [];
    const idFocus = tascaFocus.idTasques;
    const idsJaRelacionats = new Set(relacions.map((r) =>
      r.idTasca === idFocus ? r.idTascaDependent : r.idTasca
    ));
    idsJaRelacionats.add(idFocus);
    return tasquesList.filter((t) => !idsJaRelacionats.has(t.idTasques));
  };

  const toggleCandidate = (id) => {
    setSelectedCandidates((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleAfegirRelacions = async () => {
    if (!tascaFocus || !modeAfegir || selectedCandidates.length === 0) return;

    const idFocus = tascaFocus.idTasques;

    if (modeAfegir === "Pred_pre") {
      for (const cand of selectedCandidates) {
        try {
          await fetch(`${API_URL}/Novaorganitzacio.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              idTasca: cand, idTascaDependent: idFocus,
              TipusDependencia: "Pred", Motiu: motiuComu || null,
            }),
          });
        } catch (err) { /* ignore */ }
      }
    } else {
      const tipusDep = modeAfegir === "Excloent" ? "Excloent" : "Pred";
      try {
        await fetch(`${API_URL}/Novaorganitzacio.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idTasca: idFocus, idTasquesDependents: selectedCandidates,
            TipusDependencia: tipusDep, Motiu: motiuComu || null,
          }),
        });
      } catch (err) {
        alert("Error de connexió.");
      }
    }

    setModeAfegir(null);
    setSelectedCandidates([]);
    setMotiuComu("");
    fetchRelacions();
  };

  const handleDesvincular = async (idOrgTasques) => {
    if (!window.confirm("Vols desvincular aquesta relació?")) return;
    try {
      const resp = await fetch(`${API_URL}/Esborrarorganitzacio.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idOrganitzacioTasques: idOrgTasques }),
      });
      const data = await resp.json();
      if (data.success) fetchRelacions();
      else alert(data.message || "Error.");
    } catch (err) {
      alert("Error de connexió.");
    }
  };

  const handleGuardarMotiu = async () => {
    if (!editingRelId) return;
    try {
      const resp = await fetch(`${API_URL}/Modificarorganitzacio.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idOrganitzacioTasques: editingRelId, Motiu: editMotiu }),
      });
      const data = await resp.json();
      if (data.success) {
        setEditingRelId(null);
        setEditMotiu("");
        fetchRelacions();
      } else alert(data.message || "Error.");
    } catch (err) {
      alert("Error de connexió.");
    }
  };

  const candidates = getCandidates();

  return (
    <div className="dv2-entity">
      {mostraAjuda && <AjudaTreball pestanya="organitzacio" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className="dv2-pageHeader-icon" aria-hidden="true">🔗</div>
          <div>
            <h1 className="dv2-pageHeader-title">Organització</h1>
            <p className="dv2-pageHeader-subtitle">
              {treball?.idTreballIntern || treball?.idTreballs}
              {treball?.NomClient ? ` · ${treball.NomClient}` : ""}
              
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funciona l'Organització" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>Tornar</button>
        </div>
      </div>
      {subnav}
      <div className="dv2-entity-body">

      <div className="treballs-org-layout">
        {/* Panell esquerre: Quantitat | Unitats | Descripció | Estat */}
        <div className="treballs-org-panel-left">
          <h4 style={{ margin: "0 0 8px 0" }}>Tasques del treball</h4>
          <div style={{ marginBottom: 8 }}>
            <input type="text" value={fDescripcio} onChange={(e) => setFDescripcio(e.target.value)}
              placeholder="Cercar tasca..."
              style={{ width: "100%", padding: "4px 6px", fontSize: 13, border: "1px solid #ccc", borderRadius: 4 }}
            />
          </div>
          <div style={{ flex: 1, overflowY: "auto" }}>
            {tasquesFiltrades.map((t) => (
              <div
                key={t.idTasques}
                className={`treballs-tasca-mini-row ${tascaFocus?.idTasques === t.idTasques ? "selected" : ""}`}
                style={{ paddingLeft: t.idTascaPare ? 20 : 4, display: "flex", justifyContent: "space-between", alignItems: "center" }}
                onClick={() => {
                  setTascaFocus((prev) => prev?.idTasques === t.idTasques ? null : t);
                  setModeAfegir(null);
                  setSelectedCandidates([]);
                }}
              >
                <span>
                  <span style={{ color: "#888", fontSize: 12, marginRight: 4 }}>{t.Quantitat ?? ""} {t.Unitats || ""}</span>
                  {t.DescripcioTasca || "—"}
                </span>
                <span style={{ fontSize: 11, color: "#888", whiteSpace: "nowrap", marginLeft: 8 }}>
                  {mapejos.estatTasca[t.Estat] || t.Estat}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Panell dret: relacions - només descripció */}
        <div className="treballs-org-panel-right">
          {tascaFocus ? (
            <>
              <h4 style={{ margin: "0 0 4px 0" }}>
                Relacions de: <em>{tascaFocus.DescripcioTasca || "—"}</em>
              </h4>

              <div className="org-rel-header">
                <select value={filtreRelacio} onChange={(e) => setFiltreRelacio(e.target.value)}>
                  <option value="Totes">Totes</option>
                  <option value="Predecessores">Abans de</option>
                  <option value="Dependents">Després de</option>
                  <option value="Excloent">No es pot fer alhora</option>
                </select>
                <button className="Dashboard-btn-icona" title="Va abans de..." onClick={() => { setModeAfegir("Pred_pre"); setSelectedCandidates([]); }}>⬆</button>
                <button className="Dashboard-btn-icona" title="Va després de..." onClick={() => { setModeAfegir("Pred_dep"); setSelectedCandidates([]); }}>⬇</button>
                <button className="Dashboard-btn-icona" title="No es pot fer alhora que..." onClick={() => { setModeAfegir("Excloent"); setSelectedCandidates([]); }}>✕</button>
              </div>

              {modeAfegir && (
                <div style={{ border: "1px solid #ccc", borderRadius: 6, padding: 8, marginBottom: 8, background: "#fffbe6" }}>
                  <strong>
                    {modeAfegir === "Pred_pre" ? "Aquesta tasca va abans de..." : modeAfegir === "Pred_dep" ? "Aquesta tasca va després de..." : "No es pot fer alhora que..."}
                  </strong>
                  <div style={{ maxHeight: "30vh", overflowY: "auto", marginTop: 6 }}>
                    {candidates.length === 0 ? (
                      <p style={{ fontSize: 13 }}>No hi ha candidates disponibles.</p>
                    ) : (
                      candidates.map((t) => (
                        <div key={t.idTasques}
                          className={`treballs-multiselect-row ${selectedCandidates.includes(t.idTasques) ? "selected" : ""}`}
                          style={{ padding: "4px 6px", cursor: "pointer", borderBottom: "1px solid #eee" }}
                          onClick={() => toggleCandidate(t.idTasques)}
                        >
                          <input type="checkbox" checked={selectedCandidates.includes(t.idTasques)}
                            onChange={() => toggleCandidate(t.idTasques)} onClick={(e) => e.stopPropagation()} />
                          <span>{t.DescripcioTasca || "—"}</span>
                        </div>
                      ))
                    )}
                  </div>
                  <div style={{ marginTop: 6 }}>
                    <label style={{ fontSize: 13 }}>
                      Motiu comú (opcional)
                      <input type="text" className="treballs-org-motiu-input" value={motiuComu} onChange={(e) => setMotiuComu(e.target.value)} />
                    </label>
                  </div>
                  <div className="Dashboard-button-group" style={{ marginTop: 6 }}>
                    <button className="Dashboard-btn Dashboard-btn-acceptar" disabled={selectedCandidates.length === 0} onClick={handleAfegirRelacions}>
                      Confirmar ({selectedCandidates.length})
                    </button>
                    <button className="Dashboard-btn Dashboard-btn-cancelar" onClick={() => { setModeAfegir(null); setSelectedCandidates([]); }}>Cancel·lar</button>
                  </div>
                </div>
              )}

              {!modeAfegir && (
                <div style={{ flex: 1, overflowY: "auto" }}>
                  {relacionsFiltrades.length === 0 ? (
                    <p style={{ padding: 10, fontSize: 13 }}>No hi ha relacions d'aquest tipus.</p>
                  ) : (
                    <table className="Dashboard-table" style={{ tableLayout: "auto" }}>
                      <thead>
                        <tr>
                          <th className="text-left">Tipus</th>
                          <th className="text-left">Tasca relacionada</th>
                          <th className="text-left">Motiu</th>
                          <th style={{ width: 80 }}>Accions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {relacionsFiltrades.map((r) => (
                          <tr key={r.idOrganitzacioTasques}>
                            <td className="text-left">
                              {r.tipusRelatiu === "Excloent" ? "No es pot fer alhora"
                                : r.tipusRelatiu === "Predecessores" ? "Abans de" : "Després de"}
                            </td>
                            <td className="text-left">{r.descAltra || "—"}</td>
                            <td className="text-left">
                              {editingRelId === r.idOrganitzacioTasques ? (
                                <div style={{ display: "flex", gap: 4 }}>
                                  <input type="text" value={editMotiu} onChange={(e) => setEditMotiu(e.target.value)}
                                    className="treballs-org-motiu-input" style={{ flex: 1 }} />
                                  <button className="Dashboard-btn-icona" onClick={handleGuardarMotiu} title="Guardar">✓</button>
                                  <button className="Dashboard-btn-icona" onClick={() => setEditingRelId(null)} title="Cancel·lar">✕</button>
                                </div>
                              ) : (r.Motiu || "—")}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <button className="Dashboard-btn-icona" title="Editar motiu"
                                onClick={() => { setEditingRelId(r.idOrganitzacioTasques); setEditMotiu(r.Motiu || ""); }}>✎</button>
                              <button className="Dashboard-btn-icona" title="Desvincular"
                                onClick={() => handleDesvincular(r.idOrganitzacioTasques)}>✖</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </>
          ) : (
            <div style={{ padding: 20 }}>
              <p>Selecciona una tasca a l'esquerra per veure les seves dependències.</p>
            </div>
          )}
        </div>
      </div>

      </div>
    </div>
  );
}

export default Organitzacio;
